'use strict';

angular.module('DoohApps')
    .factory('ScheduleSettings', ['DoohHelper', function (DoohHelper) {

        let defaultScheduleSettings = {
            eventLimit: true
        }

        let scheduleSettings = {
            setSettings: setSettings,
        }        
        
        setSettings();        

        function setSettings(newSettings) {
            let storageSettings = newSettings || JSON.parse(localStorage.getItem('scheduleSettings')) || defaultScheduleSettings;
            Object.assign(scheduleSettings, storageSettings);
            localStorage.setItem('scheduleSettings', JSON.stringify(storageSettings))
        }

        return scheduleSettings;
    }])
